const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    SENTRY_URL: process.env.REACT_APP_SENTRY_URL,
    SENTRY_ENV: process.env.REACT_APP_SENTRY_ENV,
    MODEL_PATH_S3: process.env.REACT_APP_MODEL_PATH_S3,
    PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL,
};

export default config;
